module.exports = __webpack_public_path__ + "img/Cape.83bfab10.jpg";